export default `# scroll down to see all code

add n1, n2, n3, n4
  background: green
  label-color: black

align n1, n2, n3, n4 horizontally

n1
  label: "start"

n2, n3
  label: ""

n4
  label: "end"

n1 - n2 - n3 - n4
  label: ""

n2 - n2
  label: "loop"





`;